<script>
import { Bar } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

export default {
  extends: Bar,
  props: {
    stepSize: {
      type: Number,
      default: 10
    },
    max: {
      type: Number,
      default: 100
    },
    yAxisCurrency: {
      type: Boolean,
      default: true
    },
    yAxisPercentaje: {
      type: Boolean,
      default: false
    },
  },  
  mounted () {
    this.renderChart(
      {
        labels: [],
        datasets: [
          {
            label: 'Sin Datos',
            backgroundColor: '#f87979',
            data: []
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
            }
          }
        }
      }
    )
  },
  methods: {
    render(labels, data, stepSize, max, valorObjetivo = 0) {
      let self = this;

      if (stepSize == 0) {
        stepSize = self.stepSize;
      }
      if (max == 0) {
        max = self.max;
      }

      this.renderChart(
        {
          labels: labels,
          datasets: data
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            enabled: false,
            custom: CustomTooltips,
            intersect: true,
            mode: 'index',
            position: 'nearest',
            callbacks: {
              labelColor: function (tooltipItem, chart) {
                return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
              }
            }
          },
          legend: {
            display: true
          },
          scales: {
            xAxes: [{
              gridLines: {
                drawOnChartArea: false
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                // maxTicksLimit: 2,
                min: 0,
                max: max,
                stepSize: stepSize,
                // Include a dollar sign in the ticks
                callback: function(value, index, ticks) {
                  if (self.yAxisCurrency) {
                    return new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(parseFloat(value));
                  }
                  if (self.yAxisPercentaje) {
                    return new Intl.NumberFormat("es-AR", {style: "percent", minimumFractionDigits: 2}).format(parseFloat(value) / 100.00);
                  }
                  return value;
                  // return this.$options.filters.moneda(value);
                }                
              },
              gridLines: {
                display: true,
                // color: function(context) {
                //   if (valorObjetivo != 0) {
                //     const value = context.chart.scales['y-axis-0'].ticks[context.index];
                //     if (value === valorObjetivo) {
                //       return 'red'
                //     }
                //   }
                //   return '#c8ced3';
                // },
                // lineWidth: function(context) {
                //   if (valorObjetivo != 0) {
                //     const value = context.chart.scales['y-axis-0'].ticks[context.index];
                //     if (value === valorObjetivo) {
                //       return 3
                //     }
                //   }
                //   return 1
                // }
              }
            }],
          },
          // onAnimationComplete: function(chart) {
          //   const ctx = chart.chart.ctx;
          //   const yAxis = chart.scales['y-axis-0'];
          //   const xAxis = chart.scales['x-axis-0'];
            
          //   // Calcular la posición Y del objetivo
          //   const yPosition = yAxis.getPixelForValue(valorObjetivo);

          //   console.log(yPosition);
            
          //   // Dibujar la línea objetivo
          //   ctx.save();
          //   ctx.strokeStyle = 'red';
          //   ctx.lineWidth = 2;
          //   ctx.setLineDash([5, 5]);
          //   ctx.beginPath();
          //   ctx.moveTo(xAxis.left, yPosition);
          //   ctx.lineTo(xAxis.right, yPosition);
          //   ctx.stroke();
          //   ctx.restore();
          // }
          // plugins: [{
          //     afterDraw: function(chart) {
          //       const ctx = chart.chart.ctx;
          //       const yAxis = chart.scales['y-axis-0'];
          //       const xAxis = chart.scales['x-axis-0'];
                
          //       // Calcular la posición Y del objetivo
          //       const yPosition = yAxis.getPixelForValue(valorObjetivo);
                
          //       console.log(valorObjetivo, yPosition);
          //       // Dibujar la línea
          //       ctx.save();
          //       ctx.strokeStyle = 'red';
          //       ctx.lineWidth = 2;
          //       ctx.setLineDash([5, 5]);
          //       ctx.beginPath();
          //       ctx.moveTo(xAxis.left, yPosition);
          //       ctx.lineTo(xAxis.right, yPosition);
          //       ctx.stroke();
          //       ctx.restore();
          //     }
          //   }]          
        }
      )
    }
  }
}
</script>
